/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServicePublicDto } from './ServicePublicDto';
import {
    ServicePublicDtoFromJSON,
    ServicePublicDtoFromJSONTyped,
    ServicePublicDtoToJSON,
} from './ServicePublicDto';

/**
 * 
 * @export
 * @interface ServicesPublicDto
 */
export interface ServicesPublicDto {
    /**
     * The list of public services.
     * @type {Array<ServicePublicDto>}
     * @memberof ServicesPublicDto
     */
    items: Array<ServicePublicDto>;
}

/**
 * Check if a given object implements the ServicesPublicDto interface.
 */
export function instanceOfServicesPublicDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function ServicesPublicDtoFromJSON(json: any): ServicesPublicDto {
    return ServicesPublicDtoFromJSONTyped(json, false);
}

export function ServicesPublicDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServicesPublicDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ServicePublicDtoFromJSON)),
    };
}

export function ServicesPublicDtoToJSON(value?: ServicesPublicDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ServicePublicDtoToJSON)),
    };
}

